import { render, staticRenderFns } from "./dbj.vue?vue&type=template&id=30398996&scoped=true&"
import script from "./dbj.vue?vue&type=script&lang=js&"
export * from "./dbj.vue?vue&type=script&lang=js&"
import style0 from "./dbj.vue?vue&type=style&index=0&id=30398996&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30398996",
  null
  
)

export default component.exports